import * as yup from 'yup'

export const addVendorValidation: yup.SchemaOf<any> = yup
  .object({
    ShortCode: yup.string().required().nullable().label('Short Code'),
    VendorType: yup.string().required().nullable().label('Vendor Type'),
  })
  .required()
